function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["bodyProps", "className", "decrementButtonProps", "defaultValue", "disabled", "error", "errorPosition", "errorProps", "headerProps", "helpText", "helpTextProps", "id", "incrementButtonProps", "innerProps", "labelPosition", "labelProps", "labels", "look", "max", "min", "name", "onBlur", "onChange", "onQuantityChange", "pattern", "readOnly", "required", "showLabel", "step", "textfieldProps", "wrapperRef"],
  _excluded2 = ["errorPosition", "labelPosition", "look", "showLabel"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useState, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputErrorPositions, InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { useMounted } from "../../../../hooks/use-mounted.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import { baseInputStyle, getInputPadding, getInputBorderRadius, getInputTheme, getInputAddonButtonTheme } from "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import '@brandfolder/utilities';
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import { IconButton } from "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import { TextfieldBody } from "../../../internal/textfield/textfield-body.js";
import { TextfieldHeader } from "../../../internal/textfield/textfield-header.js";
import "../../../internal/textfield/textfield-icon.js";
import { TextfieldInner } from "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { BaseTextfield } from "../../textfield/base-textfield/base-textfield.js";
import "../../textfield/standard-textfield/standard-textfield.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardQuantity = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var bodyProps = props.bodyProps,
    className = props.className,
    decrementButtonProps = props.decrementButtonProps,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? 0 : _props$defaultValue,
    disabled = props.disabled,
    error = props.error,
    errorPosition = props.errorPosition,
    errorProps = props.errorProps,
    headerProps = props.headerProps,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    id = props.id,
    incrementButtonProps = props.incrementButtonProps,
    innerProps = props.innerProps,
    labelPosition = props.labelPosition,
    labelProps = props.labelProps,
    labels = props.labels,
    look = props.look,
    max = props.max,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    name = props.name,
    _onBlur = props.onBlur,
    _onChange = props.onChange,
    onQuantityChange = props.onQuantityChange,
    pattern = props.pattern,
    readOnly = props.readOnly,
    required = props.required,
    showLabel = props.showLabel,
    _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    textfieldProps = props.textfieldProps,
    wrapperRef = props.wrapperRef,
    otherProps = _objectWithoutProperties(props, _excluded);
  var decrementLabel = labels.decrementLabel,
    incrementLabel = labels.incrementLabel,
    label = labels.label,
    requiredLabel = labels.requiredLabel;
  var hasError = !!error;
  var hasHelpText = !!helpText;
  var hasRequired = required && !!requiredLabel;
  var helpTextId = "".concat(id, "-help-text");
  var inlineAlertId = "".concat(id, "-inline-alert");
  var isMounted = useMounted();
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var hasValue = value !== undefined;
  var atMax = hasValue && max === value;
  var atMin = hasValue && min === value;
  useEffect(function () {
    if (isMounted && onQuantityChange) {
      onQuantityChange(value);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  var onDecrement = function onDecrement() {
    if (value !== undefined) {
      var newValue = value - step;
      if (newValue >= min) {
        setValue(newValue);
      }
    }
  };
  var onIncrement = function onIncrement() {
    if (value !== undefined) {
      var newValue = value + step;
      if (max === undefined || max !== undefined && newValue <= max) {
        setValue(newValue);
      }
    }
  };
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-quantity__standard': true,
      'bf-quantity__standard--disabled': disabled,
      'bf-quantity__standard--error': hasError,
      'bf-quantity__standard--help-text': hasHelpText
    }, _defineProperty(_classnames, "bf-quantity__standard--label-".concat(labelPosition), showLabel), _defineProperty(_classnames, 'bf-quantity__standard--label-hidden', !showLabel), _defineProperty(_classnames, "bf-quantity__standard--look-".concat(look), look), _defineProperty(_classnames, 'bf-quantity__standard--readonly', readOnly), _defineProperty(_classnames, 'bf-quantity__standard--required', hasRequired), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    labelPosition: labelPosition,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(TextfieldHeader, _extends({}, headerProps, {
    error: error,
    errorPosition: errorPosition,
    errorProps: errorProps,
    htmlFor: id,
    inlineAlertId: inlineAlertId,
    label: label,
    labelPosition: labelPosition,
    labelProps: labelProps,
    required: required,
    requiredLabel: requiredLabel,
    showLabel: showLabel
  })), /*#__PURE__*/React.createElement(TextfieldBody, _extends({}, bodyProps, {
    disabled: disabled,
    error: error,
    errorPosition: errorPosition,
    errorProps: errorProps,
    helpText: helpText,
    helpTextId: helpTextId,
    helpTextProps: helpTextProps,
    inlineAlertId: inlineAlertId,
    labelPosition: labelPosition,
    look: look
  }), /*#__PURE__*/React.createElement(TextfieldInner, _extends({}, innerProps), /*#__PURE__*/React.createElement(IconButton, _extends({}, decrementButtonProps, {
    className: classnames(_defineProperty({
      'bf-quantity__button': true,
      'bf-quantity__decrement': true
    }, "".concat(decrementButtonProps === null || decrementButtonProps === void 0 ? void 0 : decrementButtonProps.className), !!(decrementButtonProps !== null && decrementButtonProps !== void 0 && decrementButtonProps.className))),
    disabled: atMin || readOnly || disabled,
    icon: FontIcons.PriorityMedium,
    label: decrementLabel,
    look: ButtonLooks.Tertiary,
    onClick: function onClick() {
      onDecrement();
    }
  })), /*#__PURE__*/React.createElement(BaseTextfield, _extends({}, textfieldProps, {
    "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
    "aria-disabled": disabled,
    "aria-invalid": hasError,
    className: classnames(_defineProperty({
      'bf-quantity__textfield': true,
      'bf-quantity__textfield--xsmall': hasValue && value >= 100 && value < 999,
      'bf-quantity__textfield--small': hasValue && value >= 1000 && value <= 9999,
      'bf-quantity__textfield--medium': hasValue && value >= 10000 && value <= 99999,
      'bf-quantity__textfield--large': hasValue && value >= 100000 && value <= 999999,
      'bf-quantity__textfield--xlarge': hasValue && value >= 1000000
    }, "".concat(textfieldProps === null || textfieldProps === void 0 ? void 0 : textfieldProps.className), !!(textfieldProps !== null && textfieldProps !== void 0 && textfieldProps.className))),
    disabled: disabled,
    id: id,
    inputMode: "numeric",
    max: max,
    min: min,
    name: name,
    onBlur: function onBlur(e) {
      var target = e.target;
      if (target.value === '') {
        setValue(defaultValue);
      }
      if (_onBlur) {
        _onBlur(e);
      }
    },
    onChange: function onChange(e) {
      var target = e.target;
      if (target.value === '') {
        setValue(undefined);
      } else if (!Number.isNaN(target.value)) {
        setValue(Number(target.value));
      }
      if (_onChange) {
        _onChange(e);
      }
    },
    pattern: pattern,
    readOnly: readOnly,
    ref: ref,
    required: required,
    step: step,
    type: "number",
    value: value
  })), /*#__PURE__*/React.createElement(IconButton, _extends({}, incrementButtonProps, {
    className: classnames(_defineProperty({
      'bf-quantity__button': true,
      'bf-quantity__increment': true
    }, "".concat(incrementButtonProps === null || incrementButtonProps === void 0 ? void 0 : incrementButtonProps.className), !!(incrementButtonProps !== null && incrementButtonProps !== void 0 && incrementButtonProps.className))),
    disabled: atMax || readOnly || disabled,
    icon: FontIcons.Plus,
    label: incrementLabel,
    look: ButtonLooks.Tertiary,
    onClick: function onClick() {
      onIncrement();
    }
  })))));
});
var Quantity = styled(BaseStandardQuantity)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .bf-textfield__inner {\n    display: flex;\n  }\n\n  .bf-quantity__textfield {\n    ", "\n    ", "\n    ", "\n    ", "\n    text-align: center;\n    width: 48px;\n    -moz-appearance: textfield;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      appearance: none;\n      margin: 0;\n    }\n  }\n\n  .bf-quantity__textfield--xsmall {\n    width: 57px;\n  }\n\n  .bf-quantity__textfield--small {\n    width: 66px;\n  }\n\n  .bf-quantity__textfield--medium {\n    width: 75px;\n  }\n\n  .bf-quantity__textfield--large {\n    width: 84px;\n  }\n\n  .bf-quantity__textfield--xlarge {\n    width: 92px;\n  }\n\n  .bf-quantity__button {\n    width: 50px;\n    ", "\n  }\n\n  .bf-quantity__decrement {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .bf-quantity__increment {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  .bf-button__font-icon {\n    font-size: 11px;\n  }\n"])), baseInputStyle, function () {
  return getInputPadding({
    after: true,
    before: true
  });
}, function () {
  return getInputBorderRadius({
    after: true,
    before: true
  });
}, function (_ref) {
  var error = _ref.error,
    look = _ref.look;
  return getInputTheme({
    after: true,
    before: true,
    error: error,
    look: look
  });
}, function (_ref2) {
  var disabled = _ref2.disabled,
    error = _ref2.error,
    look = _ref2.look;
  return getInputAddonButtonTheme({
    disabled: disabled,
    error: error,
    look: look
  });
});
var StandardQuantity = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$errorPosition = props.errorPosition,
    errorPosition = _props$errorPosition === void 0 ? InputErrorPositions.Bottom : _props$errorPosition,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Quantity, _extends({}, otherProps, {
    errorPosition: errorPosition,
    labelPosition: labelPosition,
    look: look,
    ref: ref,
    showLabel: showLabel
  })));
});
export { BaseStandardQuantity, StandardQuantity };